import { render, staticRenderFns } from "./PlusIcon.vue?vue&type=template&id=662440d4&scoped=true&"
import script from "./PlusIcon.vue?vue&type=script&lang=js&"
export * from "./PlusIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662440d4",
  null
  
)

export default component.exports